import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", match: "/" },
  { to: "/news", label: "瓜田速递", match: "/news" },
  { to: "/about", label: "关于我们", match: "/about" },
];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const handleSubscribe = () => {
    if (location.pathname !== "/") {
      navigate("/");
      window.setTimeout(() => {
        document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="sticky top-0 z-40 border-b border-background-300/70">
      {/* date ticker */}
      <div className="bg-primary-600 text-background-100">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-1.5 text-[11px] md:px-6">
          <p className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-calendar-line text-background-100/90" />
            <span>昨日瓜田 · 编辑夜报 · 2026 年 9 月 9 日</span>
          </p>
          <p className="hidden items-center gap-2 sm:flex">
            <i className="ri-megaphone-line text-background-100/90" />
            <span>以公开信息与官方回应为准 · 理性吃瓜</span>
          </p>
        </div>
      </div>

      {/* masthead */}
      <div
        className={
          "border-b transition-colors " +
          (scrolled
            ? "border-background-300/80 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50")
        }
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-water-flash-line text-xl" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-2xl font-black text-primary-600 md:text-[26px]">
                昨日吃瓜
              </span>
              <span className="text-[10px] tracking-[0.3em] text-foreground-500">
                YESTERDAY·RECAP
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-7 lg:flex" aria-label="主导航">
            {navItems.map((item) => {
              const active =
                item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={
                    "whitespace-nowrap text-sm transition-colors " +
                    (active ? "font-bold text-primary-600" : "text-foreground-700 hover:text-primary-600")
                  }
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleSubscribe}
              className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              订阅瓜报
            </button>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
              aria-label="打开菜单"
              aria-expanded={open}
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="border-t border-background-300/70 bg-background-50 lg:hidden">
            <nav className="mx-auto flex max-w-7xl flex-col px-4 py-3 md:px-6" aria-label="移动导航">
              {navItems.map((item) => {
                const active =
                  item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to);
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className={
                      "rounded-md px-3 py-2.5 text-base " +
                      (active
                        ? "bg-primary-100 font-bold text-primary-700"
                        : "text-foreground-800 hover:bg-background-100")
                    }
                  >
                    {item.label}
                  </Link>
                );
              })}
              <button
                type="button"
                onClick={handleSubscribe}
                className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                订阅瓜报
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}